"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* eslint-disable complexity */
var objMatchingPosition = function objMatchingPosition(props) {
  switch (props.position) {
    case 'top':
      return {
        bottom: '100%',
        left: '50%',
        transform: 'translateX(-50%)',
        marginBottom: props.offset || 5
      };

    case 'right':
      return {
        top: '50%',
        left: '100%',
        transform: 'translateY(-50%)',
        marginLeft: props.offset || 5
      };

    case 'bottom':
      return {
        top: '100%',
        left: '50%',
        transform: 'translateX(-50%)',
        marginTop: props.offset || 5
      };

    default:
      return {
        top: '50%',
        right: '100%',
        transform: 'translateY(-50%)',
        marginRight: props.offset || 5
      };
  }
};

var _default = function _default() {
  return {
    TooltipTitle: function TooltipTitle(_ref) {
      var _ref$props = _ref.props,
          position = _ref$props.position,
          offset = _ref$props.offset;
      return _objectSpread(_objectSpread({
        background: '#212322 0% 0% no-repeat padding-box',
        borderRadius: '6px',
        padding: 10,
        width: 'max-content',
        position: 'absolute',
        textAlign: 'left',
        font: 'normal normal normal 12px/17px Roboto',
        letterSpacing: 0,
        color: '#FFFFFF'
      }, objMatchingPosition({
        position: position,
        offset: offset
      })), {}, {
        zIndex: 999999,
        transition: 'all 0.2s ease-in-out',
        maxWidth: 250,
        whiteSpace: 'normal'
      });
    },
    Tooltip: {
      cursor: 'pointer',
      position: 'relative',
      height: 'fit-content',
      width: 'fit-content'
    }
  };
};

exports["default"] = _default;
//# sourceMappingURL=style.js.map